import {
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
  FluidCompanyContainer,
} from "components/company/v3/CompanyContainers";
import { KpisTabEnum } from "components/company/v3/menu/enums";
import Kpis from "components/financials/modern/Kpis";
import { Tabs } from "components/ui/Tabs";
import { BookTextIcon, ChartSplineIcon, Table2Icon } from "lucide-react";
import { useIntl } from "react-intl";

interface AmericanKpisBoxProps {
  tickerSymbol: string;
  tab: KpisTabEnum;
  onChangeTab: (tab: KpisTabEnum) => void;
}

export default function AmericanKpisBox({ tickerSymbol, tab, onChangeTab }: AmericanKpisBoxProps) {
  const intl = useIntl();

  return (
    <FluidCompanyContainer>
      <CompanyContentContainer className="flex-col">
        <Tabs value={tab} className="w-full" onValueChange={(value) => onChangeTab(value as KpisTabEnum)}>
          <CompanyTabsList
            activeTab={KpisTabEnum.TABLE}
            tabs={[
              {
                value: KpisTabEnum.TABLE,
                label: intl.formatMessage({
                  defaultMessage: "KPIs - Tabela",
                  description: "Aba dos KPIs",
                  id: "YFY7Rc",
                }),
                icon: <Table2Icon className="inline-flex" size={16} strokeWidth={2} />,
              },
              {
                value: KpisTabEnum.CHART,
                label: intl.formatMessage({
                  defaultMessage: "KPIs - Gráfico",
                  description: "Aba dos KPIs",
                  id: "2xZJzU",
                }),
                icon: <ChartSplineIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
              {
                value: KpisTabEnum.DOCUMENTATION,
                label: intl.formatMessage({
                  defaultMessage: "Documentação",
                  description: "Aba dos KPIs",
                  id: "fciS3f",
                }),
                icon: <BookTextIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
            ]}
          />

          <CompanyTabsContent value={KpisTabEnum.TABLE} className="overflow-auto">
            <Kpis display="table" tickerSymbol={tickerSymbol} />
          </CompanyTabsContent>
          <CompanyTabsContent value={KpisTabEnum.CHART}>
            <Kpis display="chart" tickerSymbol={tickerSymbol} />
          </CompanyTabsContent>
          <CompanyTabsContent value={KpisTabEnum.DOCUMENTATION}>
            <Kpis display="documention" tickerSymbol={tickerSymbol} />
          </CompanyTabsContent>
        </Tabs>
      </CompanyContentContainer>
    </FluidCompanyContainer>
  );
}
